import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { ApplicationNotificationService } from '../application-notification.service';

@Injectable()
export class HqGuard implements CanActivate {
  constructor(private router: Router, private authenticationService: AuthenticationService,
              private appNotificationService: ApplicationNotificationService) {
  }

  canActivate() {
    if (this.authenticationService.token) {
      if (this.authenticationService.hq) {
        return true;
      } else {
        this.appNotificationService.addGrowl('Your account does not have valid access rights.');
      }
    } else {
      this.appNotificationService.addGrowl('You need to login.');
    }
    this.router.navigate(['/login']);
    return false;
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/auth/hq.guard.ts